module.exports = __webpack_public_path__ + "img/scd_thumb.c71557dc.jpg";